import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../pages/Dashboard';
import FilterWrapper from '../pages/FilterWrapper';
import FilterList from '../pages/FilterList';
import FilterEdit from '../pages/FilterEdit';
import FilterEditFacilities from '../pages/FilterEditFacilities';
import FilterEditGeneral from '../pages/FilterEditGeneral';
import FilterEditEntities from '../pages/FilterEditEntities';
import Review from '../pages/Review';
import ReviewAvailableDomainsSettings from '../pages/ReviewAvailableDomainsSettings';
import ReviewSettingsWrapper from '../pages/ReviewSettingsWrapper';
import ReviewWrapper from '../pages/ReviewWrapper';
import PageNotFound from '../pages/error-pages/PageNotFound';
import GiftVoucherTemplates from '../pages/gift-voucher-templates/GiftVoucherTemplates';
import { session } from './middleware';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/gift-voucher-templates',
      name: 'GiftVoucherTemplates',
      component: GiftVoucherTemplates,
    },
    {
      path: '/filter',
      name: 'FilterWrapper',
      component: FilterWrapper,
      redirect: { name: 'FilterList' },
      children: [
        {
          path: 'list',
          name: 'FilterList',
          component: FilterList,
        },
        {
          path: 'edit/:id',
          name: 'FilterEdit',
          component: FilterEdit,
          redirect: { name: 'FilterEditGeneral' },
          props: true,
          children: [
            {
              path: 'general',
              name: 'FilterEditGeneral',
              component: FilterEditGeneral,
            },
            {
              path: 'facilities',
              name: 'FilterEditFacilities',
              component: FilterEditFacilities,
            },
            {
              path: 'entities',
              name: 'FilterEditEntities',
              component: FilterEditEntities,
            },
          ],
        },
      ],
    },
    {
      path: '/review',
      name: 'ReviewWrapper',
      component: ReviewWrapper,
      redirect: { name: 'Review' },
      children: [
        {
          path: 'approval',
          name: 'Review',
          component: Review,
        },
      ],
    },
    {
      path: '/review-settings',
      name: 'ReviewSettingsWrapper',
      component: ReviewSettingsWrapper,
      redirect: { name: 'ReviewAvailableDomainsSettings' },
      children: [
        {
          path: 'available-domains',
          name: 'ReviewAvailableDomainsSettings',
          component: ReviewAvailableDomainsSettings,
        },
      ],
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js